var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.is_load } }, [
    _vm.item.id > 0
      ? _c(
          "div",
          { staticClass: "categ_info" },
          [
            _c("fileload", {
              attrs: { doc_id: _vm.item.id, doc_type: "pwa_article" },
              on: { on_load: _vm.on_loading_files },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }